import { IProductInstallmentsViewConfig } from '../views/product-installments-price/ProductInstallmentsPrice';
import { IShadePickerComponentViewConfig } from '../interfaces/IShadePicker';
import { IProductPriceRangeConfig } from '../interfaces/IProductPrice';

export enum ComponentTypes {
    PRODUCT_GRID = 'productGrid',
    PRODUCT_QUICKSHOP = 'productQuickshop',
    PRODUCT_FULL = 'productFull',
    PRODUCT_BRIEF = 'productBrief',
    PRODUCT_STICKY_ADD_TO_BAG = 'productStickyAddToBag',
    PRODUCT_FILTERS = 'productGridFilters',
    SHADE_FILTERS = 'shadeFilters',
    SKU_PICKER = 'skuPicker'
}

export type allowedType =
    | IProductInstallmentsViewConfig
    | IShadePickerComponentViewConfig
    | IProductPriceRangeConfig
    | undefined;

export type ComponentTypesConfigByType = { [K in ComponentTypes]?: allowedType };
